// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Compose = function Compose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#compose-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.227 2.3.472.473a.934.934 0 0 1 0 1.325l-1.137 1.14-1.8-1.8L15.898 2.3a.934.934 0 0 1 1.325 0zm-9.032 7.708 5.243-5.246 1.8 1.8-5.246 5.243a.94.94 0 0 1-.406.238l-2.285.652.652-2.285a.93.93 0 0 1 .238-.406zm6.38-9.031L6.866 8.68a2.8 2.8 0 0 0-.715 1.215L5.035 13.8a.937.937 0 0 0 1.16 1.16l3.907-1.117c.46-.133.878-.38 1.214-.715l7.707-7.703a2.813 2.813 0 0 0 0-3.977l-.472-.472a2.813 2.813 0 0 0-3.977 0M3.437 2.5A3.44 3.44 0 0 0 0 5.938v10.625A3.44 3.44 0 0 0 3.438 20h10.625a3.44 3.44 0 0 0 3.437-3.437v-4.375a.935.935 0 0 0-.937-.938.935.935 0 0 0-.938.938v4.374c0 .864-.7 1.563-1.562 1.563H3.438c-.864 0-1.563-.7-1.563-1.562V5.938c0-.864.7-1.563 1.563-1.563h4.374c.52 0 .938-.418.938-.937a.935.935 0 0 0-.937-.938z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "compose-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
